import React, { useEffect, useRef } from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';
import { setChildren } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import BaseElement from '../base';

import HelptapEditor from '../../helpers';

import AddSigneesButton from './buttons/add-signees';
import DeleteSigneeButton from './buttons/delete-signee';

import './index.scss';

function SignaturePanel(props) {

  const containerReference = useRef(null);

  const editor = useSlateStatic();

  const elementPath = ReactEditor.findPath(editor, props.element);

  useEffect(function onLoad() {

    initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initialize() {

    const panelId = props.element.properties.panelId;
    let panel = null;

    if (typeof panelId !== 'string') {
      try {

        panel = await serverInterface.startup.signaturePanel.setupSignaturePanel({
          pageId: props.element.properties.pageId
        });

        HelptapEditor.setAttributes(editor, {
          properties: {
            ...props.element.properties,
            panelId: panel._id
          }
        }, elementPath);

      } catch (exception) {

        panel = await serverInterface.startup.pages.getPopulatedSignaturePanelByPageId(props.element.properties.pageId);

      }
    } else {
      panel = await serverInterface.startup.signaturePanel.getPopulatedSignaturePanelById(panelId);
    }

    application.cssUtility.loadCSS(import.meta.env.REACT_APP_SHARED_ASSETS_BASE_ADDRESS + '/programs/signature-panel/index.css');
    const SignaturePanelView = (await import(import.meta.env.REACT_APP_SHARED_ASSETS_BASE_ADDRESS + '/programs/signature-panel/view/index.js')).default;

    const view = new SignaturePanelView({
      panel,
      readOnly: false,
      AddSigneesButton: AddSigneesButton,
      DeleteSigneeButton
    });

    setChildren(containerReference.current, [view]);

  }

  function renderContent() {

    const mainAttributes = {
      ...props.attributes,
      contentEditable: false,
      className: 'signature-panel-content'
    };

    const containerAttributes = {
      className: 'signature-panel-wrapper',
      ref: containerReference
    };

    return <div {...mainAttributes}>
      <div {...containerAttributes}>
        <ht-spinner size="small" />
      </div>
      {props.children}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'signature-panel-main'
    };

    return <BaseElement {...baseElementProperties}>
      {renderContent()}
    </BaseElement>;

  }

  return renderMain();

}

export default SignaturePanel;